import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'
import { rem } from 'polished'
import classnames from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  min-width:100%;
  width:100%;
  align-self:stretch;
  position: absolute;
  top: ${rem(18)};
  height: ${rem(20)};

  ${mediaQueryUp.sm} {
    top: ${rem(22)};
  }
`

const CustomInput = styled.input`
  width: 100%;
  height: 100%;
  background: transparent;
  transition: color 0.3s;
  outline: none;
  border: none;
  padding: 0 ${rem(52)} 0 ${rem(48)};
  margin: 0;
  font-weight: ${props => props.theme.font.primary.weight.regular};
  font-size: ${props => props.theme.fontSize.sm};
  display:flex;
  align-items:center;
  cursor: pointer;
  position: absolute;
`

interface Props extends React.ComponentProps<typeof components.Input> {
  innerRef: (initialValue: any) => React.MutableRefObject<any>
}

function ReactSelectInput(props: Props) {
  // Destructuring helps prevent props from passing cx and
  // theme which results in warning and override the theme passing from styled-components
  const { cx, theme, className, innerRef, ...inputProps } = props

  return (
    <Container className={classnames(className, 'select-dropdown__input')}>
      <CustomInput ref={innerRef} {...inputProps} />
    </Container>
  )
}

export default ReactSelectInput
